// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"29eabccf","793":"c7cb45da","930":"25e36fea"}[chunkId] + ".chunk.css";
};